import { roundDecimal } from "@common/Common";
import { AlternativeReadModel, CriterionReadModel } from "@Evaluation/ValueAnalysis/Domain/readmodels";
import { KendoChart, KendoChartDataSerie, KendoChartOptions } from "@Kendo/Components/KendoChart";

export class RadarChartDialogViewModel
{
    opened: boolean = false;
    chart: KendoChart | null = null;
    criterionId: number | null = null;

    criteria: CriterionReadModel[] = [];
    selectedAlternatives: AlternativeReadModel[] = [];
    theme: string = "default";
    precision: number = 3;
    get selectedCriterion(): CriterionReadModel { return this.criteria.find(a => a.Id === this.criterionId); }

    setChartData(topLevel: boolean)
    {
        const criteria = topLevel ?
            this.criteria.filter(c => c.ParentId === this.criterionId) :
            this.criteria.filter(c => this.selectedCriterion.BottomIds.includes(c.Id));

        const series: KendoChartDataSerie[] = this.selectedAlternatives.map(alternative =>
        {
            const dataItems = criteria.map(criterion =>
            {
                const value = roundDecimal(alternative.Criteria.find(av => av.CriterionId === criterion.Id).Value, this.precision);
                return { Name: criterion.Name, Value: value };
            });

            const serie = new KendoChartDataSerie();
            serie.SetName(alternative.Name);
            serie.SetField("Value");
            serie.SetCategoryField("Name");
            serie.SetData(dataItems);

            return serie;
        });

        this.chart.SetDataSeries(series);
        this.chart.UpdateOptions();
    }

    show(criteria: CriterionReadModel[], selectedAlternatives: AlternativeReadModel[], theme: string, precision: number)
    {
        this.criteria = criteria;
        this.selectedAlternatives = selectedAlternatives;
        this.theme = theme;
        this.precision = precision;

        this.criterionId = this.criteria.find(c => c.ParentId == null).Id;

        const chartOptions = new KendoChartOptions();
        chartOptions.SetTooltip(true, "#= dataItem.Value #");
        chartOptions.SetRadarSeriesType();
        chartOptions.SetCategoryAxis(null, true);
        chartOptions.SetLegend(true, "bottom", 25);
        chartOptions.SetTheme(this.theme);

        this.chart = KendoChart.CreateChart(chartOptions);
        this.setChartData(true);

        this.opened = true;
    }


    close()
    {
        this.opened = false;

        this.chart = null;
    }

    renderChart()
    {
        this.chart.Render1("RadarChart");
    }
}